import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';
import './PWAUpdateToast.scss';

const PWAUpdateToast = () => {
  const [registration, setRegistration] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setRegistration(e.detail.registration);
      setShow(true);
    };

    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // Reload once the new SW takes control
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="pwa-update-toast">
      <div className="pwa-update-toast__content">
        <RefreshCw size={18} />
        <span>New version available</span>
      </div>
      <div className="pwa-update-toast__actions">
        <button className="pwa-update-toast__btn" onClick={handleUpdate}>
          Update
        </button>
        <button
          className="pwa-update-toast__close"
          onClick={() => setShow(false)}
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default PWAUpdateToast;
